import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Modal, Text } from '../../../ui-components';

export interface WarningModalProps {
    isOpen: boolean;
    onReturn: () => void;
    onConfirmClose: () => void;
}
export const WarningModal: FC<WarningModalProps> = ({ isOpen, onConfirmClose, onReturn }) => {
    const intl = useIntl();

    return (
        <Modal
            title={intl.formatMessage({
                id: 'turn-to.warning-modal.header',
                defaultMessage: 'Warning',
            })}
            id="video-modal"
            isOpen={isOpen}
            onClose={onConfirmClose}
            variant="turn-to"
        >
            <>
                <Text style="bold" size="small" margin="0.5rem 0 1.5rem" as="p">
                    <FormattedMessage
                        id="turn-to.warning-modal.text"
                        defaultMessage="Leaving the form will cause your submission to be cancelled."
                    />
                </Text>
                <Flex gap={2} flexWrap={{ base: 'wrap', sm: 'nowrap' }}>
                    <Button variant="primary-black" onClick={onReturn} wide>
                        <FormattedMessage
                            id="turn-to.warning-modal.return-button"
                            defaultMessage="Return to form"
                        />
                    </Button>
                    <Button variant="secondary" onClick={onConfirmClose} wide trim>
                        <FormattedMessage
                            id="turn-to.warning-modal.leave-button"
                            defaultMessage="Leave and Cancel Submission"
                        />
                    </Button>
                </Flex>
            </>
        </Modal>
    );
};
